module.exports = __webpack_public_path__ + "img/s.884e4327.jpg";